import { ClientGlobalSystem } from './ClientBase';

/**
 * System that monitors the current looting/pickpocketing target.
 * If the target becomes aggro'd (e.g., due to a failed pickpocket), the UI is automatically closed.
 */
export class ExternalUIAggroSystem extends ClientGlobalSystem {
  public override run(): void {
    const inventoryUI = this.clientServices.inventoryUI;
    if (!inventoryUI.state.isOpen || inventoryUI.state.lootingTargetId === null) {
      return;
    }

    const targetId = inventoryUI.state.lootingTargetId;
    const world = this.clientServices.clientWorld.getWorld();

    // If target has Aggro component AND is alive, close the UI
    if (world.hasComponent(targetId, 'Aggro') && !world.hasComponent(targetId, 'Dead')) {
      inventoryUI.close();
    }
  }
}
